export default __webpack_public_path__ + "27d36eabd2506a120ed9086c00df7491.png";